/**
 * Componente principal de la aplicación
 */

import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@/shared';
import { AuthProvider, useAuth } from '@/modules/auth/context/AuthContext';
import { SessionExpiredModal } from '@/modules/auth/components/SessionExpiredModal';
import { setUnauthorizedHandler } from '@/shared/http/client';
import { router } from './router/routes';
import './App.css';

// Componente interno para configurar el handler de 401
function AuthHandler() {
  const { logoutWithExpirationMessage, showSessionExpiredModal, closeSessionExpiredModal } = useAuth();

  useEffect(() => {
    // Configurar el handler para errores 401
    setUnauthorizedHandler(() => {
      logoutWithExpirationMessage();
    });
  }, [logoutWithExpirationMessage]);

  return (
    <>
      <SessionExpiredModal
        isOpen={showSessionExpiredModal}
        onClose={closeSessionExpiredModal}
      />
      <RouterProvider router={router} />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AuthHandler />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;

